import type { Locale } from "../schema/Locale.js";

const formatCache: Partial<Record<`${Locale}-${boolean}`, Intl.NumberFormat>> = {};
function createFormat(locale: Locale, withFraction: boolean): Intl.NumberFormat {
	return (formatCache[`${locale}-${withFraction}`] ??= new Intl.NumberFormat(locale, {
		style: "currency",
		currency: "CZK",
		minimumFractionDigits: withFraction ? 2 : 0,
		maximumFractionDigits: 2,
	}));
}

export function formatPrice(number: number | string, locale: Locale, withFraction: boolean): string {
	return createFormat(locale, withFraction).format(typeof number === "string" ? parseFloat(number) : number);
}
